<template>
  <v-layout>
    <v-flex xs5 sm2>
      <v-menu
        ref="menu"
        :close-on-content-click="false"
        v-model="menu2"
        :nudge-right="20"
        :return-value.sync="time"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <v-text-field
          v-slot:activator="{on}"
          v-model="time"
          label="Polling time"
          prepend-icon="access_time"
          readonly
        ></v-text-field>
        <v-time-picker
          v-if="menu2"
          v-model="time"
          @change="$refs.menu.save(time)"
        ></v-time-picker>
      </v-menu>
    </v-flex>
    <v-flex xs1 sm1></v-flex>
    <v-flex xs5 sm2> 
       <v-select
      v-model="selectedPollingInterval"
      :items="intervals"
      label="Polling Interval"
      required
    ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data () {
      return {
        time: null,
        menu2: false,
        modal2: false,
        selectedPollingInterval: null,
        intervals: [
          { text: '-- none --' },
          { text: 'Daily' },
          { text: '12 hours' },
          { text: '10 hours' },
          { text: '8 hours' },
          { text: '6 hours' },
          { text: '4 hours' },
          { text: '2 hours' },
          { text: '1 hour' },
          { text: '30 minutes' },
          { text: '10 minutes' },
          { text: '5 minutes' },
        ]
      }
    }
  }
</script>